import React, { useRef, useEffect } from 'react';
import { BaseButton } from '@repo/common';

import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

function VisaTypeList({ onToggle, selectedOptions = [], options = [] }) {
  // API 실패 시에만 쓰는 폴백. 서버 옵션(ELIGIBLE_VISA_TYPE)과 순서·라벨을 맞춘다
  const fallbackOptions = [
    'D-2 (학생비자)',
    'D-4 (어학연수비자)',
    'D-10 (구직비자)',
    'E-1~E-7 (취업)',
    'E-8~E-10 (비전문취업)',
    'F-1, F-3 (동반가족)',
    'F-2 (거주)',
    'F-4 (재외동포)',
    'F-5 (영주자격)',
    'F-6 (국제결혼)',
    'H-1 (관광취업)',
    'H-2 (방문취업)',
    'Any',
  ];
  const optionLabels =
    options.length > 0
      ? options.map((option) => option.optionLabel).filter(Boolean)
      : fallbackOptions;

  const listRef = useRef(null);
  const selectedRef = useRef(null);

  useEffect(() => {
    if (listRef.current && selectedRef.current) {
      listRef.current.scrollTop = selectedRef.current.offsetTop - 7;
    }
  }, [selectedOptions]);

  return (
    <div
      ref={listRef}
      className='w-full  overflow-y-auto bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02'
    >
      <ul role='menu' className='p-0 m-0 list-none'>
        {optionLabels.map((option) => {
          const isSelected = selectedOptions.includes(option);

          return (
            <li
              key={option}
              ref={isSelected ? selectedRef : null}
              className='flex items-center transition-colors duration-150 rounded-lg'
            >
              <BaseButton
                type='text'
                size='m'
                bgclass='bg-grayscale-gray00'
                borderclass='border-none'
                textclass='justify-start'
                hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                width='100%'
                onClick={(e) => {
                  e.stopPropagation();
                  onToggle(option);
                }}
                leftalign='true'
                icon={
                  isSelected ? (
                    <CheckIcon className='text-icon-primary' />
                  ) : (
                    <span className='w-4 h-[18px]' />
                  )
                }
              >
                {option}
              </BaseButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default VisaTypeList;
